module.exports = __webpack_public_path__ + "img/RegCat-student.690ce032.svg";